import React from 'react';
import PropTypes from 'prop-types';

const RailwayStationRouteRecommend = ({ railwayStationRouteProps: { stationPageUrl, code, name }, idx }) => {
  const anchorProps = stationPageUrl ? { href: stationPageUrl } : {};
  return (
    <li key={`${code}_${idx}`} className="appendBottom10">
      <a {...anchorProps} className="font14 darkGreyText railSeoWrap__rwStnListLink">
        <span className="latoBold font14 blackText">{code}</span>
        {name}
      </a>
    </li>
  );
};

RailwayStationRouteRecommend.propTypes = {
  railwayStationRouteProps: PropTypes.object,
  idx: PropTypes.number
};

export default RailwayStationRouteRecommend;
